import React from "react";
import CountUp from "react-countup";
import { BatteryFull, Cpu } from "@phosphor-icons/react";
import { DASHBOARD } from "@/constants/testIds";

export const BatteryImpact = ({ data }) => {
    if (!data) return null;
    const mins = data.critical_minerals_conserved;

    return (
        <section
            data-testid={DASHBOARD.battery}
            className="rounded-lg border border-[#1f1f22] bg-[#080808] p-6 sm:p-8 lg:p-10"
        >
            <div className="mb-6 flex flex-col gap-3 sm:mb-8 md:flex-row md:items-end md:justify-between">
                <div>
                    <span className="eviq-chip">Signature EVIQ metric</span>
                    <h2 className="mt-4 font-editorial text-2xl leading-tight text-white sm:text-3xl md:text-4xl">
                        Prevent waste, not just offset it.
                    </h2>
                    <p className="mt-2 max-w-xl text-sm text-zinc-500">
                        If even one battery replacement is delayed by a year because a driver adopts
                        healthier charging, that's real mineral demand deferred.
                    </p>
                </div>
                <span className="font-mono-metric text-[10px] uppercase tracking-[0.24em] text-zinc-600">
                    {data.methodology_note}
                </span>
            </div>

            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div className="rounded-md border border-[#1f1f22] bg-[#0a0a0a] p-6">
                    <div className="flex items-center gap-2 text-[#a3e635]">
                        <BatteryFull size={16} weight="fill" />
                        <span className="font-mono-metric text-[10px] uppercase tracking-[0.24em]">
                            Community battery life extended
                        </span>
                    </div>
                    <div className="mt-4 font-mono-metric text-4xl font-bold text-white sm:text-5xl md:text-6xl">
                        <CountUp end={data.estimated_battery_life_extended_years} separator="," duration={2} />
                        <span className="ml-2 text-base font-normal text-zinc-500">years</span>
                    </div>
                </div>
                <div className="rounded-md border border-[#1f1f22] bg-[#0a0a0a] p-6">
                    <div className="flex items-center gap-2 text-[#8b5cf6]">
                        <Cpu size={16} weight="fill" />
                        <span className="font-mono-metric text-[10px] uppercase tracking-[0.24em]">
                            Batteries kept in service longer
                        </span>
                    </div>
                    <div className="mt-4 font-mono-metric text-4xl font-bold text-white sm:text-5xl md:text-6xl">
                        <CountUp end={data.estimated_batteries_kept_in_service} separator="," duration={2} />
                    </div>
                </div>
            </div>

            <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
                {[
                    { label: "Lithium", value: mins.lithium_kg, color: "#a3e635" },
                    { label: "Nickel", value: mins.nickel_kg, color: "#06b6d4" },
                    { label: "Cobalt", value: mins.cobalt_kg, color: "#f59e0b" },
                ].map((m) => (
                    <div
                        key={m.label}
                        className="rounded-md border border-[#1f1f22] bg-[#0a0a0a] p-6"
                    >
                        <div className="flex items-center gap-2">
                            <span className="h-2 w-2 rounded-full" style={{ background: m.color }} />
                            <span className="font-mono-metric text-[10px] uppercase tracking-[0.24em] text-zinc-500">
                                {m.label} conserved
                            </span>
                        </div>
                        <div className="mt-3 font-mono-metric text-3xl font-bold text-white">
                            <CountUp end={m.value} separator="," decimals={0} duration={2} />
                            <span className="ml-1 text-sm font-normal text-zinc-500">kg</span>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default BatteryImpact;
